import AnswerButtonComponent from './AnswerButtonComponent';
import AnswerRangeComponent from './AnswerRangeComponent';

/**
 * Creates an AnswerButtonComponent
 * @param {EsgItem} answerEsgItem
 * @param {EsgItem} parentEsgItem
 * @returns {string}
 * @constructor
 */
function AnswerSelectionComponent(answerEsgItem, parentEsgItem) {
  if (answerEsgItem.item.type === 'answer_numbers') {
    return AnswerRangeComponent(answerEsgItem);
  }

  return AnswerButtonComponent(answerEsgItem, parentEsgItem);
}

export default AnswerSelectionComponent;
